import { Api } from '../base'

class Charts extends Api {
  get basePath() {
    return '/api/munio/charts'
  }

  sales() {
    return this.$get<SalesData[]>(this.$route('api.web.munio.charts.sales'))
  }

  storage() {
    return this.$get<StorageData[]>(this.$route('api.web.munio.charts.storage'))
  }

  userCountries() {
    return this.$get<UserCountriesData[]>(this.$route('api.web.munio.charts.user-countries'))
  }
}

export default Charts

export type SalesData = {
  accountId: number
  accountName: string
  shopId: number
  shopName: string
  companyId: number
  companyName: string
  date: string // YYYY-MM
  year: number
  month: number // 1-12
  totalNum: number // number of orders
  totalNet: number // total net amount (NOK)
}

export type StorageData = {
  accountId: number
  accountName: string
  totalBytes: number
}

export type UserCountriesData = {
  country: string
  totalUsers: number
}
